import metaLogo from '../assets/images/meta-logo.png'
import { blogApiUrl } from '../utils/variables'

// Note: Steam logo would need to be added to assets if needed
// For now, we'll use a placeholder or text representation

class PlatformsApi {
  static async fetchPlatforms() {
    try {
      // Use direct fetch for external API to avoid CORS issues
      const response = await fetch(`${blogApiUrl}/tracker/platforms`)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data.data
    } catch (error) {
      console.error('Error fetching platforms:', error)
      // Fallback to default platforms if API fails
      return this.getDefaultPlatforms()
    }
  }

  static getDefaultPlatforms() {
    return [
      {
        id: 'meta',
        name: 'Meta Quest Store',
        display_name: 'Meta Quest',
        icon_url: metaLogo,
        active: true,
        description: 'Standalone VR games for Meta Quest headsets.'
      },
      {
        id: 'steam',
        name: 'Steam',
        display_name: 'Steam',
        icon_url: 'https://cdn.cloudflare.steamstatic.com/favicon.ico',
        active: true,
        description: 'PC gaming platform.'
      },
      {
        id: 'apple_vision',
        name: 'Apple Vision Pro',
        display_name: 'Apple Vision',
        icon_url: 'https://dt37mjal16qgk.cloudfront.net/assets/apple_vision_icon.png',
        active: true,
        description: 'Spatial apps and games built for Apple Vision Pro.'
      },
      {
        id: 'pico',
        name: 'Pico XR Store',
        display_name: 'Pico',
        icon_url: 'https://dt37mjal16qgk.cloudfront.net/assets/pico_icon.png',
        active: true,
        description: 'Standalone VR apps and games for Pico headsets.'
      }
    ];
  }

  static getPlatformAliases(platformId) {
    const aliases = {
      'meta': ['meta', 'oculus', 'quest'],
      'steam': ['steam'],
      'apple_vision': ['apple_vision', 'apple vision', 'vision pro', 'visionos'],
      'pico': ['pico', 'pico xr', 'pico xr store']
    }
    return aliases[platformId] || []
  }

  static normalizePlatformName(platformName, platforms = []) {
    if (!platformName) return null
    
    const normalized = platformName.toLowerCase().trim()
    
    for (const platform of platforms) {
      // Check direct ID match
      if (platform.id === normalized) {
        return platform.id
      }
      // Check name match
      if (platform.name.toLowerCase() === normalized) {
        return platform.id
      }
      // Check display name match
      if (platform.display_name.toLowerCase() === normalized) {
        return platform.id
      }
      // Check aliases
      const aliases = this.getPlatformAliases(platform.id)
      if (aliases.includes(normalized)) {
        return platform.id
      }
    }
    
    return null
  }

  static getPlatformById(platformId, platforms = []) {
    return platforms.find(p => p.id === platformId) || null
  }

  static getActivePlatforms(platforms = []) {
    return platforms.filter(p => p.active)
  }

  static getPlatformIcon(platformId, platforms = []) {
    const platform = this.getPlatformById(platformId, platforms)
    return platform ? platform.icon_url : null
  }

  static getPlatformDisplayName(platformId, platforms = []) {
    const platform = this.getPlatformById(platformId, platforms)
    return platform ? platform.display_name : platformId
  }
}

export default PlatformsApi
